module.exports = __webpack_public_path__ + "img/xroad7_logo.6571c0b0.svg";